import React from 'react';
// import FAQs from 'dummy/categories';
import {FairBox} from 'components/fair';
import {connect} from 'react-redux';
import {Fairs} from 'base/api';
import {toastr} from 'react-redux-toastr';
import Modal from 'react-modal';
import { EditorState, convertToRaw, ContentState } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';

import {stateToHTML} from 'draft-js-export-html';

Modal.setAppElement('body');

class FairList extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      listFairs: [],
      items: {},
      modalIsOpen: false,
      contentDescription: ''
    }
  }

  loadFairs() {
    Fairs.actions.list.request({
      filter: {
        limit: 1000,
        include: ['categories']
      }
    }).then(response => {
      this.setState({
        listFairs: response.data
      })
    });
  }

  componentDidMount() {
    this.loadFairs();
  }

  afterActions(message) {
    toastr.removeByType("success");
    toastr.success("", message)
    this.loadFairs();
  }

  openModal(contentDescription) {
    this.setState({contentDescription, modalIsOpen: true}, () => {this.showContent(contentDescription)});
  }

  closeModal() {
    this.setState({contentDescription: '', modalIsOpen: false});
  }

  contentState(value) {
    const contentBlock = htmlToDraft(value);
    if (contentBlock) {
      const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
      const editorState = EditorState.createWithContent(contentState);

      return editorState;
    } else {
      return EditorState.createEmpty();
    }
  }

  showContent(content) {
    let container = document.getElementById('drafContent').innerHTML = content;
  }

  render() {
    let contentDescription = this.contentState(this.state.contentDescription || '');
    return (
      <div className='table-responsive'>
        <table className="table table-striped">
          <thead>
            <tr>
              <th style={{minWidth: 50, width: 50, textAlign: 'center'}}>#</th>
              <th>Tên hội chợ</th>
              <th>Lĩnh vực</th>
              <th>Trạng thái</th>
              <th>Thời gian bắt đầu</th>
              <th>Thời gian kết thúc</th>
              <th>Hành động</th>
            </tr>
          </thead>
          {
            this.state.listFairs.map((fair, i) => {

              return (
                <FairBox key={fair.id} data={fair}
                  openModal={this.openModal.bind(this)}
                  actionCallBack={this.afterActions.bind(this)}
                  index={(i + 1)}
                  reload={this.loadFairs.bind(this)}
                />
              );
            })
          }

        </table>
        <Modal
          isOpen={this.state.modalIsOpen}
          onRequestClose={this.closeModal.bind(this)}
          className='modal-desc-fair'
        >
          <h2 className='modal-title'>Nội dung</h2>
          <div className='content-desc' id='drafContent'>
          </div>
          <div className='wrap-button-modal'>
            <button className='btn btn-close' onClick={this.closeModal.bind(this)}>close</button>
          </div>
        </Modal>
      </div>
    );
  }
}

export default connect()(FairList);



// WEBPACK FOOTER //
// ./components/fair/FairList.jsx